import i18n, {use} from 'i18next';
import {initReactI18next} from 'react-i18next';

import accountEN from '../../../locales/en/account.json';
import campaignTranslationEN from '../../../locales/en/campaign.json';
import cityscanEN from '../../../locales/en/cityscan.json';
import contactFormTranslationEN from '../../../locales/en/contact_form.json';
import particlesEN from '../../../locales/en/particles.json';
import pdfCommonTranslationEN from '../../../locales/en/pdf_common.json';
import projectTranslationEN from '../../../locales/en/project.json';
import rule12ParsingTranslationEN from '../../../locales/en/rule12parsing.json';
import rulesTranslationEN from '../../../locales/en/rules.json';
import rulesEditorEN from '../../../locales/en/rules_editor.json';
import searchEN from '../../../locales/en/search.json';
import accountFR from '../../../locales/fr/account.json';
import campaignTranslationFR from '../../../locales/fr/campaign.json';
import cityscanFR from '../../../locales/fr/cityscan.json';
import contactFormTranslationFR from '../../../locales/fr/contact_form.json';
import particlesFR from '../../../locales/fr/particles.json';
import pdfCommonTranslationFR from '../../../locales/fr/pdf_common.json';
import projectTranslationFR from '../../../locales/fr/project.json';
import rule12ParsingTranslationFR from '../../../locales/fr/rule12parsing.json';
import rulesTranslationFR from '../../../locales/fr/rules.json';
import rulesEditorFR from '../../../locales/fr/rules_editor.json';
import searchFR from '../../../locales/fr/search.json';
import oclTranslationsEN from '../../../public/i18n/en.json';
import oclTranslationsFR from '../../../public/i18n/fr.json';

export const defaultNS = 'project';
export const resources = {
  en: {
    project: projectTranslationEN,
    rules: rulesTranslationEN,
    campaign: campaignTranslationEN,
    cityscan: cityscanEN,
    pdf_common: pdfCommonTranslationEN,
    account: accountEN,
    contact_form: contactFormTranslationEN,
    rule12parsing: rule12ParsingTranslationEN,
    particles: particlesEN,
    rules_editor: rulesEditorEN,
    search: searchEN,
    ocl: oclTranslationsEN,
  },
  fr: {
    project: projectTranslationFR,
    rules: rulesTranslationFR,
    campaign: campaignTranslationFR,
    cityscan: cityscanFR,
    pdf_common: pdfCommonTranslationFR,
    account: accountFR,
    contact_form: contactFormTranslationFR,
    rule12parsing: rule12ParsingTranslationFR,
    particles: particlesFR,
    rules_editor: rulesEditorFR,
    search: searchFR,
    ocl: oclTranslationsFR,
  },
} as const;

// eslint-disable-next-line react-hooks/rules-of-hooks
use(initReactI18next).init({
  resources,
  lng: 'fr',
  fallbackLng: ['fr', 'en'],
  defaultNS,
  interpolation: {
    escapeValue: false, // react already safes from xss
  },

  react: {
    bindI18n: 'loaded languageChanged',
    bindI18nStore: 'added',
  },

  keySeparator: '::',
  nsSeparator: ':::',
});

export default i18n;
